import { getSheet } from "../../layout/sheets/getSheet";

export const DateTimePickerSheet = getSheet({
  native: "bottom",
  web: "anchored",
});
